<template>
	<form
		ref="dateForm"
		name="form"
		class="date-form"
		:style="computedHeight"
	>
		<input :disabled="disabled" size="2" maxlength="2" class="day-month" placeholder="dd" name="day" :value="day"/>
		<span class="separator">/</span>
		<input :disabled="disabled" size="3" maxlength="2" class="day-month" placeholder="mm" name="month" :value="month"/>
		<span class="separator">/</span>
		<input :disabled="disabled" size="4" maxlength="4" placeholder="aaaa" name="year" :value="year"/>
	</form>
</template>
<script>
	import h from '@/shared/helper';

	function created() {
		if (this.value) {
			this.day = h.formatDate(this.value, 'DD');
			this.month = h.formatDate(this.value, 'MM');
			this.year = h.formatDate(this.value, 'YYYY');
		}
	}

	function mounted() {
		this.$refs.dateForm.oninput = this.inputForm;
	}

	function inputForm() {
		const { day, month, year } = this.$refs.dateForm;
		if (day.value) {
			this.day = Number(day.value) < 32 ? day.value : '';
			day.value = this.day;
			if (this.day.length === 2) {
				month.focus();
			}
		}
		if (month.value) {
			this.month = Number(month.value) < 13 ? month.value : '';
			month.value = this.month;
			if (this.month.length === 2 && this.day.length === 2) {
				year.focus();
			}
		}
		if (year.value) {
			this.year = Number(year.value) ? year.value : '';
			year.value = this.year;
		}
		if (this.validDate()) {
			const currentDate = new Date();
			const hours = currentDate.getHours();
			const minutes = currentDate.getMinutes();
			const seconds = currentDate.getSeconds();
			this.date = new Date(`${this.year}-${this.month}-${this.day}:${hours}:${minutes}:${seconds}`) || '';
			this.$emit('input', this.date);
		} else {
			this.date = null;
		}
	}

	function validDate() {
		const day = this.day && this.day.length === 2;
		const month = this.month && this.month.length === 2;
		const year = this.year && this.year.length === 4;
		return h.allTrue(day, month, year);
	}

	function computedHeight() {
		const border = `border-radius: ${this.height / 2}px`;
		return `height:${this.height}px;${border}`;
	}

	function updateValue(newDate) {
		if (typeof newDate === 'string') {
			[this.year, this.month, this.day] = newDate.split('-');
		} else {
			[this.year, this.month, this.day] = h.formatDate(newDate, 'YYYY-MM-DD').split('-');
		}
	}

	function data() {
		return {
			day: '',
			month: '',
			year: '',
			date: '',
		};
	}

	export default {
		name: 'base-date',
		computed: {
			computedHeight,
		},
		created,
		data,
		methods: {
			inputForm,
			updateValue,
			validDate,
		},
		mounted,
		props: {
			disabled: {
				default: false,
				type: Boolean,
			},
			height: {
				default: 30,
				type: Number,
			},
			value: null,
		},
		watch: {
			value: updateValue,
		},
	};
</script>

<style lang="scss" scoped>
	.date-form {
		background-color: white;
		border: 1px solid color(grey-icon);
		padding-left: 10px;
		border-radius: 5px !important;
		input {
			height: 100%;
		}

		input:focus {
			outline: none;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/shared/inputs/base-date.vue